"use strict";

var _interopRequireDefault = require("/app/node_modules/@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPeritos = getPeritos;
exports.downloadPdf = downloadPdf;

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.url.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var PERITOS_API = process.env.VUE_APP_CONSULTAS_URL + '/perito';

function getPeritos(_x) {
  return _getPeritos.apply(this, arguments);
}

function _getPeritos() {
  _getPeritos = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(fuero) {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.get(PERITOS_API, {
              params: {
                fuero: fuero
              }
            });

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getPeritos.apply(this, arguments);
}

function downloadPdf(_x2) {
  return _downloadPdf.apply(this, arguments);
}

function _downloadPdf() {
  _downloadPdf = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
    var tab, response, pdf, url, timer;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // Abrir durante el clic evita que el navegador bloquee la pestaña tras la petición.
            tab = window.open('', '_blank');

            if (tab) {
              _context2.next = 3;
              break;
            }

            throw new Error('Permití las ventanas emergentes para abrir el PDF.');

          case 3:
            tab.opener = null;
            _context2.prev = 4;
            _context2.next = 7;
            return _axios.default.get("".concat(PERITOS_API, "/").concat(id, "/file"), {
              responseType: 'blob',
              headers: {
                Accept: 'application/pdf'
              }
            });

          case 7:
            response = _context2.sent;

            if (!tab.closed) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return");

          case 10:
            pdf = new Blob([response.data], {
              type: 'application/pdf'
            });
            url = URL.createObjectURL(pdf);
            tab.location.replace(url); // Mantener el PDF disponible para visualizarlo y guardarlo hasta cerrar la pestaña.

            timer = window.setInterval(function () {
              if (tab.closed) {
                URL.revokeObjectURL(url);
                window.clearInterval(timer);
              }
            }, 1000);
            _context2.next = 20;
            break;

          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](4);
            tab.close();
            throw new Error('No se pudo descargar el PDF del padrón seleccionado.');

          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 16]]);
  }));
  return _downloadPdf.apply(this, arguments);
}